import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';


export default function LineChart({ title = 'Trend', categories = [], data = [] }) {
const options = {
chart: { type: 'spline', height: 320 },
title: { text: title },
xAxis: { categories: categories || [], title: { text: 'Date' } },
yAxis: { title: { text: 'Value' }, allowDecimals: false, min: 0 },
series: [{ name: title, data: data || [] }],
credits: { enabled: false },
tooltip: { shared: true },
};


return <HighchartsReact highcharts={Highcharts} options={options} />;
}